export const sceneBuild = [
  {
    name: 'Hunter Zinc',
    material: 'zahner',
    imageUrl: require('../static/Context/Zahner/Hunter.jpg'),
    imageUrlTile: require('../static/Context/Zahner/Hunter_T.jpg'),
    flavorText:
      'One of many custom patinas in development at Zahner, the first large-scale project to use the surface was the eponymous Hunter Museum in Chattanooga, TN for Architect Randall Stout Architects. The same patina was used on the Art Gallery of Alberta in Edmonton, Canada.',
    link: 'https://www.azahner.com/materials/hunter-zinc/',
    pdfLink: 'https://zahner-wordpress-media.s3.amazonaws.com/wp-content/uploads/2021/04/22105420/zahner-hunter-zinc.pdf',
    mechanical: false,
  },
  {
    name: 'Blackened Zinc',
    material: 'zahner',
    imageUrl: require('../static/Context/Zahner/b001Zinc.jpg'),
    imageUrlTile: require('../static/Context/Zahner/b001Zinc.jpg'),
    flavorText:
      'One of many custom patinas in development at Zahner, the first large-scale project to use the surface was the eponymous Hunter Museum in Chattanooga, TN for Architect Randall Stout Architects. The same patina was used on the Art Gallery of Alberta in Edmonton, Canada.',
    link: 'https://www.azahner.com/labs/zinc-concepts/',
    pdfLink: '',
    mechanical: false,
  },
  {
    name: 'Roano Zinc',
    material: 'zahner',
    imageUrl: require('../static/Context/Zahner/Roano.jpg'),
    imageUrlTile: require('../static/Context/Zahner/Roano_R2.jpg'),
    flavorText:
      'Roano Zinc is a lead-free, preweathered patina on zinc sheet metal, a proprietary, enduring finish developed by Zahner. The sophisticated material is part of Zahner’s line of raw patinated products, which are designed to age like tanned leather or vintage wine.',
    link: 'https://www.azahner.com/materials/roano-zinc/',
    pdfLink: 'https://zahner-wordpress-media.s3.amazonaws.com/wp-content/uploads/2021/04/22105459/zahner-roano-zinc.pdf',
    mechanical: false,
  },
  {
    name: 'Baroque Zinc',
    material: 'zahner',
    imageUrl: require('../static/Context/Zahner/Baroque_T.jpg'),
    imageUrlTile: require('../static/Context/Zahner/Baroque_T.jpg'),
    flavorText:
      'Roano Zinc is a lead-free, preweathered patina on zinc sheet metal, a proprietary, enduring finish developed by Zahner. The sophisticated material is part of Zahner’s line of raw patinated products, which are designed to age like tanned leather or vintage wine.',
    link: 'https://www.azahner.com/materials/baroque-zinc/',
    pdfLink: 'https://zahner-wordpress-media.s3.amazonaws.com/wp-content/uploads/2021/04/22105427/zahner-pamp-baroque.pdf',
    mechanical: false,
  },
  {
    name: 'Solanum Steel',
    material: 'zahner',
    imageUrl: require('../static/Context/Zahner/Solanum.jpg'),
    imageUrlTile: require('../static/Context/Zahner/Solanum_T.jpg'),
    flavorText:
      'Solanum Steel provides a range of resonant tones on an enduring surface. The surface is produced by accelerating the natural weathering process and stabilizing the result.',
    link: 'https://www.azahner.com/materials/solanum-steel/',
    pdfLink: 'https://zahner-wordpress-media.s3.amazonaws.com/wp-content/uploads/2021/04/22105442/zahner-solanum-steel.pdf',
    mechanical: true,
  },
  {
    name: 'AngelHair Stainless Steel',
    material: 'zahner',
    imageUrl: require('../static/Context/Zahner/AngelHair.jpg'),
    imageUrlTile: require('../static/Context/Zahner/AngelHair_T.jpg'),
    flavorText:
      'Angel Hair is a Zahner material process developed to soften the high-reflectivity of standard grain finishes. The patented process uses precision-controlled machinery to etch stainless steel with a fine grain. Available on a variety of metal alloys, this is the finest, smoothest, and most uniform light-diffusion metal surface available for architectural metal.',
    link: 'https://www.azahner.com/materials/angel-hair/',
    pdfLink: 'https://zahner-wordpress-media.s3.amazonaws.com/wp-content/uploads/2021/04/22105434/zahner-pamp-angel-hair.pdf',
    mechanical: true,
  },
  {
    name: 'GB 60',
    material: 'zahner',
    imageUrl: require('../static/Context/Zahner/gb60_T.jpg'),
    imageUrlTile: require('../static/Context/Zahner/gb60_T.jpg'),
    flavorText:
      'Angel Hair is a Zahner material process developed to soften the high-reflectivity of standard grain finishes. The patented process uses precision-controlled machinery to etch stainless steel with a fine grain. Available on a variety of metal alloys, this is the finest, smoothest, and most uniform light-diffusion metal surface available for architectural metal.',
    link: 'https://www.azahner.com/materials/gb-60/',
    pdfLink: 'https://zahner-wordpress-media.s3.amazonaws.com/wp-content/uploads/2021/04/22105414/zahner-gb60.pdf',
    mechanical: true,
  },
  {
    name: 'Dirty Penny Copper',
    material: 'zahner',
    imageUrl: require('../static/Context/Zahner/DirtyPenny.jpg'),
    imageUrlTile: require('../static/Context/Zahner/DirtyPenny_T.jpg'),
    flavorText:
      'Dirty Penny copper is a premium surface developed by Zahner to provide artists and architects with a stunning architectural surface unlike any other. The preweathered copper features light and dark tones ranging from blues to greens and reds.\nAn iridescent surface, the material benefits from a microfilm which develops on the exterior layer of the material. The oxidized layer is like a living protecting barrier which grows and evolves as it further oxidizes.',
    link: 'https://www.azahner.com/materials/dirty-penny-copper/',
    pdfLink: 'https://zahner-wordpress-media.s3.amazonaws.com/wp-content/uploads/2021/04/22105021/zahner-dirty-penny.pdf',
    mechanical: false,
  },
  {
    name: 'Star Blue Copper',
    material: 'zahner',
    imageUrl: require('../static/Context/Zahner/StarBlueCopper.jpg'),
    imageUrlTile: require('../static/Context/Zahner/StarBlueCopper_T.jpg'),
    flavorText:
      'To get the aged copper look of ancient domes requires entire centuries of weathering in conditions that are neither too dry nor too humid. Zahner uses a technique that speeds up this process.',
    link: 'https://www.azahner.com/materials/star-blue-copper/',
    pdfLink: 'https://zahner-wordpress-media.s3.amazonaws.com/wp-content/uploads/2021/04/22105451/zahner-pamp-star-blue.pdf',
    mechanical: false,
  },
  {
    name: 'Oscura Blackened Steel',
    material: 'zahner',
    imageUrl: require('../static/Context/Zahner/OscuraBlackenedSteel.jpg'),
    imageUrlTile: require('../static/Context/Zahner/OscuraBlackenedSteel_T.jpg'),
    flavorText:
      'To get the aged copper look of ancient domes requires entire centuries of weathering in conditions that are neither too dry nor too humid. Zahner uses a technique that speeds up this process.',
    link: 'https://www.azahner.com/materials/blackened-steel/',
    pdfLink: '',
    mechanical: false,
  },
  {
    name: 'Iridescent Zinc',
    material: 'zahner',
    view: 'R',
    imageUrl: require('../static/Context/Zahner/Iridescent_T.jpg'),
    imageUrlTile: require('../static/Context/Zahner/Iridescent_T.jpg'),
    flavorText:
      'To get the aged copper look of ancient domes requires entire centuries of weathering in conditions that are neither too dry nor too humid. Zahner uses a technique that speeds up this process.',
    link: 'https://www.azahner.com/labs/zinc-concepts/',
    pdfLink: '',
    mechanical: false,
  },
  {
    name: 'Pink Titanium',
    material: 'zahner',
    view: 'R',
    imageUrl: require('../static/Context/Zahner/PinkTitanium.jpg'),
    imageUrlTile: require('../static/Context/Zahner/PinkTitanium.jpg'),
    flavorText:
      'k',
    link: 'https://www.azahner.com/materials/titanium/',
    pdfLink: '',
    mechanical: true,
  },

  // {
  //   name: 'Cement Board',
  //   material: 'industrial',
  //   imageUrl: require('../static/Context/Industrial/CementBoard_T.jpg'),
  //   imageUrlTile: require('../static/Context/Industrial/CementBoard_T.jpg'),
  //   flavorText:
  //     '',
  //   link: 't',
  //   mechanical: false,
  // },
  // {
  //   name: 'Compressed Gravel',
  //   material: 'industrial',
  //   imageUrl: require('../static/Context/Industrial/CompressedGravel_T.jpg'),
  //   imageUrlTile: require('../static/Context/Industrial/CompressedGravel_T.jpg'),
  //   flavorText:
  //     '',
  //   link: 't',
  //   mechanical: false,
  // },
  {
    name: 'Concrete',
    material: 'industrial',
    imageUrl: require('../static/Context/Industrial/Concrete.jpg'),
    imageUrlTile: require('../static/Context/Industrial/Concrete1_T.jpg'),
    flavorText:
      '',
    link: 't',
    mechanical: false,
  },
  {
    name: 'Plaster',
    material: 'industrial',
    imageUrl: require('../static/Context/Industrial/Plaster_T.jpg'),
    imageUrlTile: require('../static/Context/Industrial/Plaster_T.jpg'),
    flavorText:
      '',
    link: 't',
    mechanical: false,
  },
  // {
  //   name: 'Porous Concrete',
  //   material: 'industrial',
  //   imageUrl: require('../static/Context/Industrial/PorousConcrete_T.jpg'),
  //   imageUrlTile: require('../static/Context/Industrial/PorousConcrete_T.jpg'),
  //   flavorText:
  //     '',
  //   link: 't',
  //   mechanical: false,
  // },

  {
    name: 'Marble',
    material: 'tile',
    imageUrl: require('../static/Context/Tile/Marble.jpg'),
    imageUrlTile: require('../static/Context/Tile/Marble.jpg'),
    // imageUrlTile: require('../static/Context/Tile/Marble_T.jpg'),
    flavorText: 't',
    link: 't',
    mechanical: false,
  },
  {
    name: 'Travertine',
    material: 'tile',
    imageUrl: require('../static/Context/Tile/Travertine.jpg'),
    imageUrlTile: require('../static/Context/Tile/Travertine.jpg'),
    // imageUrlTile: require('../static/Context/Tile/Travertine_T.jpg'),
    flavorText: 't',
    link: 't',
    mechanical: false,
  },
  {
    name: 'Basalt',
    material: 'tile',
    imageUrl: require('../static/Context/Tile/Basalt_S.jpg'),
    imageUrlTile: require('../static/Context/Tile/Basalt_S.jpg'),
    // imageUrlTile: require('../static/Context/Tile/Travertine_T.jpg'),
    flavorText: 't',
    link: 't',
    mechanical: false,
  },
  // {
  //   name: 'Board Formed Concrete',
  //   material: 'tile',
  //   imageUrl: require('../static/Context/Tile/BoardFormedConcrete_T.jpg'),
  //   imageUrlTile: require('../static/Context/Tile/BoardFormedConcrete_T.jpg'),
  //   flavorText: 't',
  //   link: 't',
  //   mechanical: false,
  // },
  // {
  //   name: 'Brick',
  //   material: 'tile',
  //   imageUrl: require('../static/Context/Tile/Brick_T.jpg'),
  //   imageUrlTile: require('../static/Context/Tile/Brick_T.jpg'),
  //   flavorText: 't',
  //   link: 't',
  //   mechanical: false,
  // },
  // {
  //   name: 'LimeStone',
  //   material: 'tile',
  //   imageUrl: require('../static/Context/Tile/LimeStone_T.jpg'),
  //   imageUrlTile: require('../static/Context/Tile/LimeStone_T.jpg'),
  //   flavorText: 't',
  //   link: 't',
  //   mechanical: false,
  // },
  // {
  //   name: 'Subway Tile',
  //   material: 'tile',
  //   imageUrl: require('../static/Context/Tile/SubwayTile_T.jpg'),
  //   imageUrlTile: require('../static/Context/Tile/SubwayTile_T.jpg'),
  //   flavorText: 't',
  //   link: 't',
  //   mechanical: false,
  // },
  {
    name: 'Terrazo',
    material: 'tile',
    imageUrl: require('../static/Context/Tile/Terrazo_T.jpg'),
    imageUrlTile: require('../static/Context/Tile/Terrazo_T.jpg'),
    flavorText: 't',
    link: 't',
    mechanical: false,
  },

  {
    name: 'Cedar',
    material: 'wood',
    imageUrl: require('../static/Context/Wood/Cedar_T.jpg'),
    imageUrlTile: require('../static/Context/Wood/Cedar_T.jpg'),
    flavorText: 't',
    link: 't',
    mechanical: false,
  },
  {
    name: 'AmericanOak',
    material: 'wood',
    imageUrl: require('../static/Context/Wood/Oak_T.jpg'),
    imageUrlTile: require('../static/Context/Wood/Oak_T.jpg'),
    flavorText: 't',
    link: 't',
    mechanical: false,
  },
  {
    name: 'EuropeanAsh',
    material: 'wood',
    imageUrl: require('../static/Context/Wood/EuropeanAsh.jpg'),
    imageUrlTile: require('../static/Context/Wood/EuropeanAsh.jpg'),
    flavorText: 't',
    link: 't',
    mechanical: false,
  },
  {
    name: 'Plywood',
    material: 'wood',
    imageUrl: require('../static/Context/Wood/Plywood_T.jpg'),
    imageUrlTile: require('../static/Context/Wood/Plywood_T.jpg'),
    flavorText: 't',
    link: 't',
    mechanical: false,
  },
  {
    name: 'Walnut',
    material: 'wood',
    imageUrl: require('../static/Context/Wood/Walnut_T.jpg'),
    imageUrlTile: require('../static/Context/Wood/Walnut_T.jpg'),
    flavorText: 't',
    link: 't',
    mechanical: false,
  },
  {
    name: 'Charred Timber',
    material: 'wood',
    imageUrl: require('../static/Context/Wood/CharredTimber_T.jpg'),
    imageUrlTile: require('../static/Context/Wood/CharredTimber_T.jpg'),
    flavorText: 't',
    link: 't',
    mechanical: false,
  },

  {
    name: 'Dewey Panic Grass',
    material: 'nature',
    imageUrl: require('../static/Context/Nature/DeweyBlue_Panicum_Grass.png'),
    imageUrlTile: require('../static/Context/Nature/DeweyBlue_Panicum_Grass.png'),
    imageUrlTileRoom: [
      "",
      require('../static/Context/Nature/Dewey-Panic-Grass_R1.png'),
      require('../static/Context/Nature/Dewey-Panic-Grass_R2.png'),
      require('../static/Context/Nature/Dewey-Panic-Grass_R3.png'),
    ],
    imageUrlTileLand: [
      "",
      require('../static/Context/Nature/Dewey-Panic-Grass_L1.png'),
      require('../static/Context/Nature/Dewey-Panic-Grass_L2.png'),
      require('../static/Context/Nature/Dewey-Panic-Grass_L3.png'),
    ],
    flavorText: 't',
    link: 't',
    mechanical: false,
  },
  {
    name: "Queen Annes Lace",
    material: 'nature',
    imageUrl: require('../static/Context/Nature/QueenAnnes_Lace.png'),
    imageUrlTile: require('../static/Context/Nature/QueenAnnes_Lace.png'),
    imageUrlTileRoom: [
      "",
      require('../static/Context/Nature/Queen-Annes-Lace_R1.png'),
      require('../static/Context/Nature/Queen-Annes-Lace_R2.png'),
      require('../static/Context/Nature/Queen-Annes-Lace_R3.png'),
    ],
    imageUrlTileLand: [
      "",
      require('../static/Context/Nature/Queen-Annes-Lace_L1.png'),
      require('../static/Context/Nature/Queen-Annes-Lace_L2.png'),
      require('../static/Context/Nature/Queen-Annes-Lace_L3.png'),
    ],
    flavorText: 't',
    link: 't',
    mechanical: false,
  },
  {
    name: 'foxtail lilies',
    material: 'nature',
    imageUrl: require('../static/Context/Nature/Foxtail_Lilies.png'),
    imageUrlTile: require('../static/Context/Nature/Foxtail_Lilies.png'),
    imageUrlTileRoom: [
      "",
      require('../static/Context/Nature/Foxtail-Lily_R1.png'),
      require('../static/Context/Nature/Foxtail-Lily_R2.png'),
      require('../static/Context/Nature/Foxtail-Lily_R3.png'),
    ],
    imageUrlTileLand: [
      "",
      require('../static/Context/Nature/Foxtail-Lily_L1.png'),
      require('../static/Context/Nature/Foxtail-Lily_L2.png'),
      require('../static/Context/Nature/Foxtail-Lily_L3.png'),
    ],
    flavorText: 't',
    link: 't',
    mechanical: false,
  },
  {
    name: 'Maidenhair Fern',
    material: 'nature',
    imageUrl: require('../static/Context/Nature/MaidenhairFern.png'),
    imageUrlTile: require('../static/Context/Nature/MaidenhairFern.png'),
    imageUrlTileRoom: [
      "",
      require('../static/Context/Nature/Maidenhair-Fern_R1.png'),
      require('../static/Context/Nature/Maidenhair-Fern_R2.png'),
      require('../static/Context/Nature/Maidenhair-Fern_R3.png'),
    ],
    imageUrlTileLand: [
      "",
      require('../static/Context/Nature/Maidenhair-Fern_L1.png'),
      require('../static/Context/Nature/Maidenhair-Fern_L2.png'),
      require('../static/Context/Nature/Maidenhair-Fern_L3.png'),
    ],
    flavorText: 't',
    link: 't',
    mechanical: false,
  },
  {
    name: 'Prairie Gayfeather',
    material: 'nature',
    imageUrl: require('../static/Context/Nature/Prairie-Gayfeather.png'),
    imageUrlTile: require('../static/Context/Nature/Prairie-Gayfeather.png'),
    imageUrlTileRoom: [
      "",
      require('../static/Context/Nature/Prarie-Gayfeather_R1.png'),
      require('../static/Context/Nature/Prarie-Gayfeather_R2.png'),
      require('../static/Context/Nature/Prarie-Gayfeather_R3.png'),
    ],
    imageUrlTileLand: [
      "",
      require('../static/Context/Nature/Prarie-Gayfeather_L1.png'),
      require('../static/Context/Nature/Prarie-Gayfeather_L2.png'),
      require('../static/Context/Nature/Prarie-Gayfeather_L3.png'),
    ],
    flavorText: 't',
    link: 't',
    mechanical: false,
  },

  {
    name: 'entourage',
    material: 'entourage',
    imageUrl: require('../static/Context/Entourage/Entourage_L2.png'),
    imageUrlTile: require('../static/Context/Entourage/Entourage_L2.png'),
    imageUrlTileRoom: [
      "",
      require('../static/Context/Entourage/Entourage_R1.png'),
      require('../static/Context/Entourage/Entourage_R2.png'),
      require('../static/Context/Entourage/Entourage_R3.png'),
    ],
    imageUrlTileLand: [
      "",
      require('../static/Context/Entourage/Entourage_L1.png'),
      require('../static/Context/Entourage/Entourage_L2.png'),
      require('../static/Context/Entourage/Entourage_L3.png'),
    ],
    flavorText: 't',
    link: 't',
    mechanical: false,
  },
]

export default sceneBuild
